"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import "../../marken/marken.css";

import { TopSectionMarken } from "../../marken/sections/TopSection";
import { AutoVerkaufenGrid } from "@/common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";

import höchstenPreis from "@/assets/auto-verkaufen/Frau-verkauft-ihr-auto.webp";
import BannerImage1 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig1.avif";
import BannerImage2 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig2.avif";
import BannerImage3 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig3.avif";
import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";

// Ratgeber SERVERSEITIG rendern (dynamic OHNE die SSR-Abschaltung, Playbook 2.6):
// die sechs "Mehr zum Thema"-Kacheln verlinken u. a. /auto-verkaufen.
const Ratgeber = dynamic(() =>
  import("@/components/Ratgeber/Ratgeber").then((m) => m.default)
);

// Only needed when the user reaches step 12; avoid loading auth-related JS/CSS on initial paint.
const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function MeistverkaufteGebrauchtwagen() {
  const [step, setStep] = useState(1);
  // selected values
  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionMarken
        title="Meistverkaufte Gebrauchtwagen 2025 - Trends, Topseller und Tipps"
        link="/guides/meistverkaufte-gebrauchtwagen"
        linkname="Meistverkaufte Gebrauchtwagen 2025"
        text={
          <>
            84% der Autoeinfachlos-Kunden bekommen mehr Geld.*{" "}
            <br className="desktop" />
            Hol dir deine kostenlose und sofortige Bewertung.
          </>
        }
        removePadding={true}
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/auto-verkaufen"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="Die beliebtesten Gebrauchtwagen"
              leftText={
                <>
                  <p>
                    Der Gebrauchtwagenmarkt ist ständig in Bewegung. Welche
                    Fahrzeuge 2025 besonders gefragt sind, hängt von Faktoren wie
                    Preis-Leistung, Zuverlässigkeit, Verbrauch und Image ab. Wer
                    ein Auto kaufen oder verkaufen möchte, profitiert davon, die
                    aktuell beliebtesten Modelle zu kennen. In diesem ausführlichen
                    Überblick erfährst du, welche Marken und Modelle in Österreich
                    2025 die Ranglisten anführen, warum diese Fahrzeuge so beliebt
                    sind und wie sich das auf deinen Verkaufspreis auswirkt.
                  </p>
                </>
              }
              rightFirstTitle="Marktübersicht 2025"
              rightFirstText={
                <>
                  <p>
                    Im ersten Halbjahr 2025 zeichnen sich klare Trends ab:
                    Fahrzeuge des Volkswagen‑Konzerns dominieren weiterhin die
                    Zulassungsstatistiken. Der Marktanteil von SUVs steigt weiter,
                    während Kompaktwagen und Kleinwagen stabil bleiben.
                    Elektroautos legen zu, vor allem dank des Tesla Model Y und
                    des VW ID.4.
                  </p>
                </>
              }
              rightSecondTitle="Top‑Marken nach Neuzulassungen (2025):"
              rightSecondText={
                <>
                  <p>
                    <strong>Gesamtmarkt</strong>
                    <br />
                    284.978
                  </p>

                  <ol className="custom-ordered-list">
                    <li>
                      <strong>VW</strong>
                      <br />
                      40.581
                    </li>
                    <li>
                      <strong>Skoda</strong>
                      <br />
                      30.087
                    </li>
                    <li>
                      <strong>BMW</strong>
                      <br />
                      19.216
                    </li>
                    <li>
                      <strong>Audi</strong>
                      <br />
                      16.565
                    </li>
                    <li>
                      <strong>Dacia</strong>
                      <br />
                      13.231
                    </li>
                    <li>
                      <strong>Mercedes</strong>
                      <br />
                      13.228
                    </li>
                    <li>
                      <strong>Hyundai</strong>
                      <br />
                      12.923
                    </li>
                    <li>
                      <strong>Seat</strong>
                      <br />
                      12.768
                    </li>
                    <li>
                      <strong>Toyota</strong>
                      <br />
                      11.323
                    </li>
                    <li>
                      <strong>Cupra</strong>
                      <br />
                      11.218
                    </li>
                  </ol>

                  <p>*Quelle https://www.krone.at/4014387</p>
                </>
              }
            />

            <div className="Banner-sections">
              <BildTextInfo
                image={BannerImage3}
                revert
                h2
                isBig
                fontSize="36px"
                title="Beliebteste Modelle 2025 (Neuzulassungen)"
                alt="Beliebteste Modelle 2025 (Neuzulassungen)"
                text={
                  <>
                    <ol className="custom-ordered-list">
                      <li>
                        <strong>Skoda Octavia</strong>
                        <br />
                        7892
                      </li>
                      <li>
                        <strong>VW Golf</strong>
                        <br />
                        6744
                      </li>
                      <li>
                        <strong>BMW X1</strong>
                        <br />
                        5218
                      </li>
                      <li>
                        <strong>Seat Ibiza</strong>
                        <br />
                        5137
                      </li>
                      <li>
                        <strong>Toyota Yaris</strong>
                        <br />
                        4521
                      </li>
                      <li>
                        <strong>VW Tiguan</strong>
                        <br />
                        4492
                      </li>
                      <li>
                        <strong>Tesla Model Y</strong>
                        <br />
                        4342
                      </li>
                      <li>
                        <strong>Skoda Karoq</strong>
                        <br />
                        4332
                      </li>
                      <li>
                        <strong>Skoda Fabia</strong>
                        <br />
                        4266
                      </li>
                      <li>
                        <strong>Dacia Sandero</strong>
                        <br />
                        4220
                      </li>
                    </ol>

                    <p>*Quelle https://www.krone.at/4014387</p>
                  </>
                }
              />

              <BildTextInfo
                image={BannerImage1}
                h2
                isBig
                fontSize="36px"
                title="Gründe für die Popularität der Topseller"
                alt="Gründe für die Popularität der Topseller"
                text={
                  <>
                    <ul className="custom-unordered-list">
                      <li>
                        <strong>Preis-Leistungs-Verhältnis:</strong> Modelle wie
                        Octavia, Golf oder Dacia Duster bieten viel Auto fürs Geld.
                        Sie sind sparsam, zuverlässig und wartungsarm.
                      </li>
                      <li>
                        <strong>Vielseitigkeit:</strong> Kompakte SUVs wie BMW X1
                        oder Skoda Karoq passen in die Stadt, bieten aber auch genug
                        Platz für Familien.
                      </li>
                      <li>
                        <strong>Alternative Antriebe:</strong> Autos wie Tesla
                        Model Y oder Toyota Yaris Hybrid profitieren von
                        Steuervergünstigungen und Umweltboni.
                      </li>
                      <li>
                        <strong>Markenimage:</strong> Deutsche Premiumhersteller
                        stehen für Qualität; sie erzielen hohe Restwerte.
                      </li>
                    </ul>
                  </>
                }
              />

              <BildTextInfo
                image={BannerImage2}
                revert
                h2
                isBig
                fontSize="36px"
                title="Auswirkungen auf den Gebrauchtwagenverkauf"
                alt="Auswirkungen auf den Gebrauchtwagenverkauf"
                text={
                  <>
                    <p>
                      Besonders gefragte Modelle erzielen hohe Preise, weil viele
                      Käufer gezielt nach ihnen suchen. Für dich bedeutet das:
                    </p>
                    <ul className="custom-unordered-list">
                      <li>
                        Wenn du eines dieser Modelle besitzt, kannst du den
                        Verkaufspreis höher ansetzen.
                      </li>
                      <li>
                        Eine gute Wartung, wenige Vorbesitzer und eine gefragte
                        Farbe (Schwarz, Weiß, Grau) erhöhen den Wert zusätzlich.
                      </li>
                      <li>
                        Seltene oder exklusive Extras (z. B. Panoramadach,
                        Premium-Soundsystem) steigern die Attraktivität.
                      </li>
                      <li>
                        Auch Elektro- oder Hybridfahrzeuge profitieren von der
                        wachsenden Nachfrage; der Wertverlust ist geringer als bei
                        herkömmlichen Verbrennern.
                      </li>
                    </ul>
                  </>
                }
              />

              <BildTextInfo
                image={BannerImage3}
                h2
                isBig
                fontSize="36px"
                title="Tipps für Käufer und Verkäufer"
                alt="Tipps für Käufer und Verkäufer"
                text={
                  <>
                    <p>
                      <strong>Für Käufer:</strong>
                    </p>
                    <ul className="custom-unordered-list">
                      <li>
                        Prüfe bei beliebten Modellen mögliche Warteschlangen oder
                        Lieferengpässe.
                      </li>
                      <li>
                        Achte auf scheckheftgepflegte Fahrzeuge und prüfe
                        Servicehistorie.
                      </li>
                      <li>
                        Vergleiche Preise regional – in Städten sind manche
                        Fahrzeuge teurer als auf dem Land.
                      </li>
                    </ul>

                    <p>
                      <strong>Für Verkäufer:</strong>
                    </p>
                    <ul className="custom-unordered-list">
                      <li>Nutze den aktuellen Trend, um einen guten Preis zu erzielen.</li>
                      <li>Bereite das Auto optisch auf (Reinigung, kleine Reparaturen).</li>
                      <li>
                        Erwähne im Inserat Extras, niedrige Laufleistung und
                        Wartungshistorie.
                      </li>
                      <li>
                        Bei Elektroautos: Liefere Informationen zur Akku-Garantie
                        und Restkapazität mit.
                      </li>
                    </ul>
                  </>
                }
              />

              <BildTextInfo
                image={BannerImage1}
                revert
                h2
                isBig
                fontSize="36px"
                title="Blick nach vorn - Trends 2027 und darüber hinaus"
                alt="Blick nach vorn - Trends 2027 und darüber hinaus"
                text={
                  <>
                    <p>
                      Die Elektromobilität wird weiter zunehmen, vor allem durch
                      neue Modelle aus China und von etablierten Herstellern.
                      Kompakte SUVs und Crossovers bleiben im Trend, während
                      Minivans weiter verlieren. Fahrzeuge mit alternativen
                      Kraftstoffen wie Wasserstoff oder synthetischen E‑Fuels
                      werden vereinzelt erscheinen, bleiben aber zunächst
                      Nischenprodukte. Software-Updates, Autonomes Fahren und
                      Abo-Modelle werden den Markt verändern.
                    </p>
                  </>
                }
              />
            </div>

            <div style={{ paddingTop: "120px" }}>
              <Ratgeber
                title="Mehr zum Thema meistverkaufte Gebrauchtwagen"
                kaputtesAuto
                unfallAuto
                autoExport
                autoBewerten
                autoVerkaufen
                listenpreisBerechnen
              />
            </div>

            <div className="Banner-sections-marken">
              <BildTextInfo
                image={höchstenPreis}
                h2
                fontSize="36px"
                title="Fazit zum Thema Meistverkaufte Gebrauchtwagen"
                alt="Frau sitzt in einem Auto und nutzt ihr Smartphone, um mit Autoeinfachlos ihr Auto zu verkaufen."
                text={
                  <>
                    <p>
                      Die meistverkauften Gebrauchtwagen 2025 in Österreich stammen
                      vor allem aus dem Volkswagen‑Konzern, ergänzt um erfolgreiche
                      Modelle von BMW, Tesla und Dacia. Sie bieten Zuverlässigkeit,
                      gutes Preis-Leistungs-Verhältnis und hohe Nachfrage. Wenn du
                      ein solches Fahrzeug besitzt, hast du beste Chancen auf einen
                      schnellen und lukrativen Verkauf. Mit Autoeinfachlos kannst
                      du den Prozess optimieren: Wir ermitteln den Marktwert und
                      vermitteln das Auto an einen unserer 5 000 Händler – schnell,
                      sicher und zu einem Top-Preis.
                    </p>
                  </>
                }
              />
            </div>
          </div>
          <Banner
            link="/auto-verkaufen"
            title="Jetzt Auto kostenlos bewerten & sicher verkaufen"
          />
        </div>
      )}
    </div>
  );
}

export default MeistverkaufteGebrauchtwagen;

